import React, { Component, Fragment } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getTestCenters,
  deleteTestCenter,
} from "../../actions/testcenterActions";
import { Link } from "react-router-dom";

class TCHomeTable extends Component {
  state = {
    tcId: "",
  };

  setTCId = (id) => {
    this.setState({
      tcId: id,
    });
  };

  onDeleteClick = (id) => {
    this.props.deleteTestCenter(id);
    location.reload();
  };

  componentDidMount() {
    this.props.getTestCenters();
  }
  render() {
    const { testcenters } = this.props;
    return (
      <>
        <div className="row">
          <div className="col-md-6 col-lg-9">
            <h3 className="mb-4">COVID-19 Test Centers</h3>
          </div>
          <div className="col-md-6 col-lg-3">
            <button
              className="btn btn-success btn mb-4 float-md-right"
              style={{ fontWeight: "500" }}
            >
              <Link className="text-white" to="/admin/testcenters/create">
                New Test Center
              </Link>
            </button>
          </div>
        </div>
        <Table className="table table-hover">
          <Thead>
            <Tr>
              <Th>Site Name</Th>
              <Th>Address</Th>
              <Th>City/Town</Th>
              <Th>ZipCode</Th>
              <Th>Permanent</Th>
              <Th>Pop-Up</Th>
              <Th className="actions-table">Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {testcenters.reverse().map((tc, a) => (
              <Fragment key={a}>
                <Tr>
                  <Td>{tc.name}</Td>
                  <Td>{tc.location.street}</Td>
                  <Td>{tc.location.city}</Td>
                  <Td>{tc.location.zipcode}</Td>
                  <Td>
                    {tc.permanentLocation ? (
                      <i className="fas fa-check text-success"></i>
                    ) : (
                      <i className="fas fa-minus text-danger"></i>
                    )}
                  </Td>
                  <Td>
                    {!tc.permanentLocation ? (
                      <i className="fas fa-check text-success"></i>
                    ) : (
                      <i className="fas fa-minus text-danger"></i>
                    )}
                  </Td>
                  <Td>
                    <button
                      type="button"
                      className="btn btn-outline-primary mr-1"
                    >
                      <Link to={`/admin/testcenters/edit/${tc._id}`}>
                        <i className="far fa-edit text-primary"></i>
                      </Link>
                    </button>
                    <button
                      type="button"
                      onClick={this.setTCId.bind(this, tc._id)}
                      data-toggle="modal"
                      data-target="#exampleModal"
                      className="btn btn-outline-danger"
                    >
                      <i className="far fa-trash-alt text-danger"></i>
                    </button>
                  </Td>
                </Tr>
              </Fragment>
            ))}
          </Tbody>
        </Table>
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Delete Test Center
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                ¿Are you sure you want to delete this test center?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  onClick={this.onDeleteClick.bind(this, this.state.tcId)}
                  type="button"
                  className="btn btn-danger"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

TCHomeTable.propTypes = {
  testcenters: PropTypes.array.isRequired,
  getTestCenters: PropTypes.func.isRequired,
  deleteTestCenter: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  testcenters: state.testcenter.testcenters,
});

export default connect(mapStateToProps, {
  deleteTestCenter,
  getTestCenters,
})(TCHomeTable);
